import styled from 'styled-components';

export const Wrapper = styled.div `
    width:100%;
    margin-top: 20px;
    .info-title {
      margin: 20px 10px;
    }   
    .btn-group {
      margin-top: 10px;
    }
    .registeredMember {
      margin: 10px auto;
      padding: 10px 5px;
      font-size: 14px;
      background-color: #F1F1F1;
    }
`
